import { render } from "./BrandActionButtons.vue?vue&type=template&id=068fe89a&scoped=true"
import script from "./BrandActionButtons.vue?vue&type=script&lang=js"
export * from "./BrandActionButtons.vue?vue&type=script&lang=js"

import "./BrandActionButtons.vue?vue&type=style&index=0&id=068fe89a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068fe89a"]])

export default __exports__